import React, { useState, useRef } from 'react';

import { ViewAllBtn } from '../../../../components/custom';

import useVisibleClips from '../../../../hooks/useVisibleClips';

import { useProjectStore } from '../../../../stores/project';

import { AnalysisFile } from '../../../../types';

import {
  ClipPreview,
  ClipPreviewController,
} from '../../components/clipPreview';

import AnalysisClipBlock from './analysisClipBlock';

interface Props {
  clips: AnalysisFile[];
  handleDelete: (video: AnalysisFile) => void;
}

const ClipsGroup: React.FC<Props> = (props) => {
  const { clips, handleDelete } = props;

  const isPortrait =
    useProjectStore((state) => state.currentProject?.videoMode) === 'portrait';

  const [isCollapsed, setIsCollapsed] = useState(true);

  const previewRef = useRef<ClipPreviewController>(null);

  const { visibleClips, showViewAllBtn, containerRef } = useVisibleClips({
    clips,
    isCollapsed,
    isPortrait,
  });

  return (
    <React.Fragment>
      <ClipPreview ref={previewRef} />

      <div
        ref={containerRef}
        className="w-full flex flex-wrap justify-start gap-4"
      >
        {visibleClips.map((clip) => (
          <AnalysisClipBlock
            key={clip.elementId}
            clip={clip}
            onDelete={() => handleDelete(clip)}
            previewRef={previewRef}
          />
        ))}

        {showViewAllBtn && (
          <ViewAllBtn
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            isPortrait={isPortrait}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default ClipsGroup;
